import { AxCalendarTrinity } from '../../../Components/AxCalendar/AxCalendar';
import { I18nHelper, Translations } from "../../../Lib/Helper/I18nHelper";
import { AxProdSelection } from '../axProdSelection';
import { Product } from '../../../Models/Tickets/Product';
import { AxScrollspy, ScrollSubject } from '../../../Components/AxScrollspy/AxScrollspy';
import { ProgressBar, ProgressBarMode } from '../../Global/Progressbar';
import { AxLoad } from '../../../Lib/AxSystem/AxLoad';
import { CheckMinMaxConstraintResult, PackageMinMaxConstraint } from "../../Packages/PackageMinMaxConstraint";
import tippy from 'tippy.js';

export abstract class SubCCalendar {
    private DatePattern: string;

    private StartMonth;
    private StartYear;

    protected Calendar: AxCalendarTrinity;
    protected ProductList: ProductDay[] = [];
    protected ProductSelection: AxProdSelection;
    protected LoadingTickets: boolean;
    protected NextLoadRequested: boolean;
    protected Currency: string;

    private hasTimeSlots: boolean;

    private ScrollSpy: AxScrollspy;

    constructor(private _I18nHelper = new I18nHelper(),
        private _Progressbar = new ProgressBar()
    ) { }

    abstract LoadTickets(month: number, year: number): void;

    Init(initData: CalendarDataInit) {
        this._Progressbar.Init({
            Mode: initData.hasTimeSlots ? ProgressBarMode.Suballotment : ProgressBarMode.Default,
            Progress: 0
        });
        $('#product_selection__setting_overlay').show();

        this.DatePattern = initData.DatePatternYear;
        this.StartMonth = initData.Month;
        this.StartYear = initData.Year;

        this.Currency = initData.Currency;
        this.hasTimeSlots = initData.hasTimeSlots;

        this.Calendar = new AxCalendarTrinity();
        this.ProductSelection = AxLoad.GetModule<AxProdSelection>("AxProdSelection");
        this.ProductSelection.CancelGoesBack = true;

        this.ScrollSpy = new AxScrollspy('.axc__month-header', 56, 1);
        this.ScrollSpy.getSubject().subscribe(x => this.ScrollSpyListener(x));

        this.Calendar.LoadingSubject.subscribe(x => {
            this.LoadTickets(parseInt(x.format('MM')), parseInt(x.format('YYYY')));
            this.ScrollSpy.update();
        });

        $('#calendarWrapper-header--next').click(x => {
            let $targets = $('.axc__month-header');
            if (this.ScrollSpy.getCurrentTarget() == null || ($targets.length >= 2 && $targets[$targets.length - 2].id == this.ScrollSpy.getCurrentTarget().Id)) {
                this.Calendar.next(true);
            }
            this.ScrollSpy.next();
        });
        $('#calendarWrapper-header--previous').click(x => { this.ScrollSpy.previous() });

        this.Calendar.showCalendar(initData.Month, initData.Year, {
            StartOfWeek: initData.StartOfWeek,
            Lang: initData.Lang,
            StartDate: moment(),
            DatePattern: initData.DatePattern,
            Months: 2,
            RootElement: 'calendarWrapper--trinity',
            WeekdayLegendSelector: '.calendarWrapper--trinity-legend',
            EndDate: moment(initData.EndDate, "YYYY-MM-DD")
        });

        this.ProductSelection.InteractionSubject.subscribe(x => {
            this.ActivateDay(x, this);
            this.UpdatePrice(false);
        });

        window.addEventListener("scroll", ev => {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                if (!this.LoadingTickets) {
                    this.Calendar.next(true);
                } else {
                    this.NextLoadRequested = true;
                }
            }
        });

        if ($('#ticket_quantity').length > 0) {
            const instance = tippy(document.querySelector('#ticket_quantity'), {
                content: this._I18nHelper.GetTranslation(Translations.SelectAtLeastOneTicket),
                placement: 'right',
                trigger: 'manual',
                interactive: true,
                theme: 'material',
            });
            instance.hide();
            $('#calendarWrapper--trinity').click(() => {
                const hasQuantity = this.ProductSelection.GetTotalQuantity() > 0;

                if (!hasQuantity) {
                    $('#ticket_quantity').addClass('ax-border-radius ticket_quantity-border-ticketv4');
                    instance.show();
                }
                else {
                    () => instance.hide();
                    () => instance.destroy();
                    $('#ticket_quantity').removeClass('ax-border-radius ticket_quantity-border-ticketv4');
                }
            });
        }
    }

    ScrollSpyListener(subject: ScrollSubject) {
        if (subject.Target != null) {
            $('#calendarWrapper-header--monthname').html($(subject.Target).data('name'));
        } else {
            let dt: moment.Moment = moment(`${this.StartYear}-${this.StartMonth}-01`, "YYYY-MM-DD");
            $('#calendarWrapper-header--monthname').html(dt.format('MMMM'));
        }
    }

    SwitchDate(month: number, year: number) {
        this.Calendar.showCalendar(month, year);
        this.LoadTickets(month, year);
    }

    ActivateDaySub(elem: Element, parentScope: SubCCalendar) {
        parentScope.ProductSelection.InteractionSubject.next(elem);
    }

    UpdatePrice(IsFirstLoad: boolean) {
        let totalQuantity = 0;

        if (typeof this.ProductList != 'undefined') {
            for (let prodList of this.ProductList) {
                let totalAmount: number = 0;
                let totalAmountWithoutDiscount: number = 0;
                for (let prod of prodList.Products) {
                    let currentProd = this.ProductSelection.ProductListTmp.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);
                    let frontendViewProd = this.ProductSelection.ProductList.find(x => x.SubProductIdentifier == prod.SubProductIdentifier);
                    if (currentProd == null || frontendViewProd == null) continue;

                    prod.Quantity = currentProd.Quantity;
                    totalQuantity += prod.Quantity;
                    if (prod.Quantity > 0) {
                        totalAmount += (prod.Quantity * this.ProductSelection.GetPrice(prod.Price));
                        totalAmountWithoutDiscount += (prod.Quantity *
                            this.ProductSelection.GetPrice(prod.OriginalPrice));
                    }
                }
                let price = this.ProductSelection.GetPriceString(totalAmount);
                let priceWithoutDiscount = this.ProductSelection.GetPriceString(totalAmountWithoutDiscount);

                if (IsFirstLoad) {
                    this.Calendar.removeCellClass(prodList.Date, 'allotment__notificiation--info');
                }

                this.Calendar.removeCellClass(prodList.Date, 'allotment__notificiation--off');

                if (!this.CheckProductQuantity(prodList)) {
                    this.Calendar.addCellClass(prodList.Date, 'allotment__notificiation--off');
                    let activeDay = this.Calendar.DeactivateDay(prodList.Date);
                    if (activeDay) {
                        this.DeactivateCurrentDay();
                    }
                }
                else {
                    this.Calendar.ActivateDay(prodList.Date);
                    if (prodList.TimeSlotInfo.filter(x => x.AvailableSlots <= x.WarningThreshold).length > 0) {
                        if (IsFirstLoad) {
                            this.Calendar.addCellClass(prodList.Date, 'allotment__notificiation--info');
                        }

                    } else if (prodList.TimeSlotInfo.filter(x => x.AvailableSlots <= x.LimitedThreshold).length > 0) {
                        if (IsFirstLoad) {
                            this.Calendar.addCellClass(prodList.Date, 'allotment__notificiation--info');
                        }
                        this.Calendar.ActivateDay(prodList.Date);
                    }
                }

                let priceDiscountPercentage = -1 * Math.round((1 - (totalAmount / totalAmountWithoutDiscount)) * 100);
                this.Calendar.updatePrice(prodList.Date, price, priceWithoutDiscount, priceDiscountPercentage);
            }

            this.Calendar.toggleCalendarBlock(totalQuantity === 0);
            this.UpdateButton(this.ProductSelection.GetTotalQuantity(), this.ProductSelection.getSelectedDate());
        }
    }

    CheckProductQuantity(product: ProductDay) {
        let confList: TimeSlotKeyTotalQuantity[] = [];

        for (let prod of product.Products.filter(x => x.TimeSlotGroupKeys != null)) {
            for (let groupKey of prod.TimeSlotGroupKeys) {
                let existingEntry = confList.find(x => x.timeSlotGroupKey === groupKey);
                if (existingEntry == null) {
                    confList.push({
                        timeSlotGroupKey: groupKey,
                        totalQuantity: prod.Quantity
                    });
                } else {
                    existingEntry.totalQuantity += prod.Quantity;
                }
            }
        }

        if (this.hasTimeSlots && confList.length === 0) {
            return false;
        }

        for (let cont of confList) {
            let timeSlotInfo = product.TimeSlotInfo.filter(x => x.TimeSlotGroupKey === cont.timeSlotGroupKey);

            if (timeSlotInfo.filter(x => (x.AvailableSlots - cont.totalQuantity) >= 0).length === 0) {
                return false;
            }
        }
        return true;
    }

    DeactivateCurrentDay() {
        $('.product_selection__setting_date--placeholder').removeClass('d-none');
        $('.product_selection__setting_date').addClass('d-none').html('');
        $('.prod_selection__summary').fadeOut('fast');
        $('.prod_selection__selection-submit').attr('disabled', 'disabled');
        this.ProductSelection.InteractionSubject.next(null);
    }

    UpdateButton(quantity: number, date: moment.Moment) {
        let checkMinMaxConstraintResult = new CheckMinMaxConstraintResult();

        let minMaxConstraintModule = AxLoad.GetModule<PackageMinMaxConstraint>('PackageMinMaxConstraint');
        checkMinMaxConstraintResult.minMaxOk = true;

        if (minMaxConstraintModule != null) {
            checkMinMaxConstraintResult = minMaxConstraintModule.CheckMinMaxConstraint(quantity);
        };

        if (quantity > 0 && checkMinMaxConstraintResult.minMaxOk) {
            if (typeof date == 'undefined') {
                $('.prod_selection__selection-submit').text(this._I18nHelper.GetTranslation(Translations.SelectDate));
                $('.prod_selection__selection-submit').attr('disabled', 'disabled');
            } else {
                $('.prod_selection__selection-submit').text(this._I18nHelper.GetTranslation(Translations.Continue));
                $('.prod_selection__selection-submit').removeAttr('disabled');
            }

            $('#ticket_calendar').removeClass('ticketv4-opacity-5');
            $('#ticket_calendar').addClass('ticketv4-opacity-0');
            $('#ticket_quantity').removeClass('ax-border-radius ticket_quantity-border-ticketv4');
        } else if (quantity > 0 && !checkMinMaxConstraintResult.minMaxOk) {
            $('.prod_selection__selection-submit').attr('disabled', 'disabled');
            $('.prod_selection__selection-submit').html(checkMinMaxConstraintResult.errorMessage);

        } else {
            $('.prod_selection__selection-submit').attr('disabled', 'disabled');
            $('.prod_selection__selection-submit').text(this._I18nHelper.GetTranslation(Translations.SelectTicket));
            $('#ticket_calendar').removeClass('ticketv4-opacity-0');
            $('#ticket_calendar').addClass('ticketv4-opacity-5');
            document.getElementById("calendarWrapper--trinity").style.cursor = "not-allowed";
        }

    }

    ActivateDay(elem: Element, parentScope: SubCCalendar) {
        if (elem != null) {
            let summaryText: string;
            let date: moment.Moment = moment($(elem).data('date'), "YYYY-MM-DD");

            this.ProductSelection.SetSelectedDate(date);

            let productDay: ProductDay = parentScope.ProductList.find(x => x.Date == $(elem).data('date'));
            let totalQuantity: number = parentScope.ProductSelection.GetTotalQuantity();

            if (productDay.TimeSlotInfo.length === 0 || this.CheckProductQuantity(productDay)) {
                parentScope.ProductSelection.SetProductListTmp(productDay.Products, false);

                summaryText = totalQuantity.toString();

                if (totalQuantity == 1) {
                    summaryText += ` ${parentScope._I18nHelper.GetTranslation(Translations.Ticket)}`;
                } else {
                    summaryText += ` ${parentScope._I18nHelper.GetTranslation(Translations.Tickets)}`;
                }

                $('.prod_selection__date--input').val($(elem).data('date'));
                $('.prod_selection__summary-date').html(date.format(parentScope.DatePattern));
                $('.prod_selection__summary-subtotal').html(summaryText);
                $('.prod_selection__summary-subtotal--price').html(parentScope.ProductSelection.Total);

                $('.product_selection__setting_date--placeholder').addClass('d-none');
                $('.product_selection__setting_date').removeClass('d-none').html(date.format(parentScope.DatePattern));
                $('.prod_selection__summary').fadeIn('fast');
                if ($('#infobtn').hasClass('ax-info-btn-mobile')) {
                    $('#infobtn').removeClass('ax-info-btn-mobile');
                }
                $('#infobtn').addClass('ax-info-btn-mobile');
            }
        }
    }
}

class TimeSlotKeyTotalQuantity {
    timeSlotGroupKey: number;
    totalQuantity: number;
}

export interface CalendarData {
    DatePattern: string;
    DatePatternYear: string;
    StartOfWeek: number;
    EndDate?: string;
    Lang: string;

    ProjNr: number;
}

export interface CalendarDataInit extends CalendarData {
    Year: number;
    Month: number;
    Currency: string;
    hasTimeSlots: boolean;
}

export interface TimeSlotInfo {
    TimeSlotGroupKey: number;
    AvailableSlots: number;
    LimitedThreshold: number;
    WarningThreshold: number;
    MaxSlots: number;
}

class ProductDay {
    Date: string;
    Products: Product[];
    TimeSlotInfo: TimeSlotInfo[];
}
